<div class="map">
    <svg class="btn-icn-fullscreen" (click)="fullscreen.emit()"><use [attr.xlink:href]="'assets/icons.svg#icn-fullscreen'" /></svg>
    <svg class="btn-icn-center" (click)="ZoomToPolyExtend('waterway')"><use [attr.xlink:href]="'assets/icons.svg#icn-recenter'" /></svg>
    <div *ngIf="loading" class="loading">Loading...</div>
</div>
<div class="sidebar">
     <img [src]="LegendUrl | safe" class="legend" />
</div>
